<template>
    <div ref="inputAddressDialog">
        <el-dialog
                v-model="visible"
                :title="i18n.tkey('lang_card_forward')"
                :width="dialogWidth"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                @closed="submitClose"
        >
            <shareCard />
        </el-dialog>
    </div>
</template>

<script setup>
    import {getCurrentInstance, inject, onMounted, ref, toRef} from "vue";
    import shareCard from "@/components/shopopee/card/shareCard"

    const { proxy } = getCurrentInstance()

    import { useShareinfo } from '@/stores/shareinfo'

    const i18n = inject("i18n")

    const shareInfoRef = toRef(useShareinfo())

    const componentWidth = ref(375)
    const dialogWidth = ref("90%")

    const visible = ref(true)

    function submitClose(){
        visible.value = false
        shareInfoRef.value.cardId = null
    }

    onMounted(() => {
        componentWidth.value = proxy.$refs.inputAddressDialog.offsetWidth

        if (componentWidth.value < 900){
            dialogWidth.value = "90%"
        }else{
            dialogWidth.value = "900"
        }
    })
</script>

<style scoped>

</style>